module.exports = __webpack_public_path__ + "static/media/avantor.a270be88.png";